"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),i=require("react/jsx-runtime"),n=require("@vds/type-lockups"),s=require("@plans/type-lockups"),t=require("styled-components"),a=require("@vds/buttons"),l=require("@vds/icons"),r=require("@vds-tokens/core"),d=require("@vds/typography"),o=require("@vds/tooltips"),c=require("@vds/utilities"),p=require("@plans/utilities");function u(e){return e&&e.__esModule?e:{default:e}}var f=u(t);const j=f.default.div.withConfig({displayName:"TitleWrapperLayout",componentId:"VDS__sc-11yfujz-0"})`
  display: flex;
  flex-direction: column;
`,x=f.default.div.withConfig({displayName:"MiddleWrapper",componentId:"VDS__sc-11yfujz-1"})`
  align-content: flex-end;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`,m=f.default.div.withConfig({displayName:"ActionWrapper",componentId:"VDS__sc-11yfujz-2"})`
  display: flex;
  flex-direction: row;
  gap: ${r.LayoutTokens.space["8X"].value};
  padding-top: ${r.LayoutTokens.space["4X"].value};
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding-top: ${r.LayoutTokens.space["8X"].value};
  }
`,g=f.default.div.withConfig({displayName:"Action",componentId:"VDS__sc-11yfujz-3"})`
  display: flex;
  flex-direction: row;
`,y=f.default.div.withConfig({displayName:"IconWrapper",componentId:"VDS__sc-11yfujz-4"})`
  padding-right: ${r.LayoutTokens.space["2X"].value};
`,h=f.default.div.withConfig({displayName:"PricingWrapper",componentId:"VDS__sc-11yfujz-5"})`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-left: ${r.LayoutTokens.space["6X"].value};
  width: 100%;
  @media (max-width: ${p.breakpoints.tabletSmall.min}) {
    padding-left: ${r.LayoutTokens.space["4X"].value};
  }
  ${({hideOnMobile:e})=>e&&`\n    @media (max-width: ${p.breakpoints.tabletSmall.min}) {\n      display: none;\n    }\n  `}
`,v=f.default.div.withConfig({displayName:"PriceWrapperDesktop",componentId:"VDS__sc-11yfujz-6"})`
  flex-wrap: nowrap;
  @media (max-width: 768px) {
    display: none;
  }
`,w=f.default.div.withConfig({displayName:"PriceWrapperMobile",componentId:"VDS__sc-11yfujz-7"})`
  flex-wrap: nowrap;
  @media (min-width: 768px) {
    display: none;
  }
`,_=f.default.div.withConfig({displayName:"MobileFullPricingWrapper",componentId:"VDS__sc-11yfujz-8"})`
  padding-top: ${r.LayoutTokens.space["2X"].value};
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    // 🤢 Mobile media query - Harry plz tokenize
    display: none;
  }
`,b=f.default.div.withConfig({displayName:"FullSuspendedWrapper",componentId:"VDS__sc-11yfujz-9"})`
  align-items: flex-end;
  display: flex;
  flex-direction: row;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    align-items: center;
  }
`,z=f.default.div.withConfig({displayName:"FullSuspendedTooltipWrapper",componentId:"VDS__sc-11yfujz-10"})`
  display: flex;
  flex-direction: column;
  justify-content: end;
`,S=f.default.div.withConfig({displayName:"FullSuspendedHelperTextWrapper",componentId:"VDS__sc-11yfujz-11"})`
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: 100px;
`,k=f.default.div.withConfig({displayName:"PriceWrapper",componentId:"VDS__sc-11yfujz-12"})`
  padding-right: ${r.LayoutTokens.space["1X"].value};
`,O=f.default.div.withConfig({displayName:"FullWrapper",componentId:"VDS__sc-11yfujz-13"})`
  display: flex;
  flex-direction: row;
`,T=f.default.div.withConfig({displayName:"FullTooltipWrapper",componentId:"VDS__sc-11yfujz-14"})`
  display: flex;
  flex-direction: column;
  justify-content: end;
`,D=f.default.div.withConfig({displayName:"FullPriceWrapper",componentId:"VDS__sc-11yfujz-15"})`
  padding-right: ${r.LayoutTokens.space["1X"].value};
`,I=e=>{const{actions:n,surface:s,viewport:t}=e;return i.jsx(m,{children:n&&n.map(((e,n)=>i.jsxs(g,{children:[e.icon&&i.jsx(y,{children:i.jsx(l.Icon,Object.assign({surface:s,size:"mobile"===t?"small":"large"},e.icon))}),e.link&&i.jsx(a.TextLink,Object.assign({surface:s,size:"large",type:"standAlone"},e.link))]},`action-${n}`)))})},L=n=>{const{oldPrice:t,price:a,helperText:l,tooltip:r,surface:c}=n,p=e.__rest(n,["oldPrice","price","helperText","tooltip","surface"]);return i.jsxs(b,{children:[i.jsx(k,{children:t&&i.jsx(s.Pricing,Object.assign({surface:c},p,{price:t,term:"none",strikethrough:!0}))}),i.jsx(k,{children:i.jsx(s.Pricing,Object.assign({surface:c},p,{price:a,term:l?"none":void 0}))}),l&&i.jsxs(i.Fragment,{children:[i.jsx(w,{children:i.jsx(S,{children:i.jsx(d.Body,Object.assign({color:"light"===c?"#000000":"#ffffff"},l,{size:"medium",primitive:"span"}))})}),i.jsx(v,{children:i.jsx(S,{children:i.jsx(d.Body,Object.assign({color:"light"===c?"#000000":"#ffffff"},l,{size:"large",primitive:"span"}))})})]}),r&&i.jsx(z,{children:i.jsx(o.Tooltip,Object.assign({surface:c},r))})]})},V=n=>{const{tooltip:t,surface:a}=n,l=e.__rest(n,["tooltip","surface"]);return i.jsxs(O,{children:[i.jsx(D,{children:i.jsx(s.Pricing,Object.assign({surface:a},l))}),t&&i.jsx(T,{children:i.jsx(o.Tooltip,Object.assign({surface:a},t))})]})},C=e=>i.jsxs(i.Fragment,{children:[i.jsx(v,{children:i.jsx(s.Pricing,Object.assign({},e,{size:"2XLarge"}))}),i.jsx(w,{children:i.jsx(s.Pricing,Object.assign({},e,{size:"XLarge"}))})]});var N=c.withVDSManager((({title:e,eyebrow:s,surface:t="light",variant:a="inline",pricing:l,viewport:r,actions:d=[]})=>{const o={title:e},c="full"===a,p="fullSuspended"===a||c;return p&&s&&(o.eyebrow=s),i.jsxs(j,{children:[i.jsxs(x,{children:[i.jsx(n.TitleLockup,{data:o,surface:t}),l&&i.jsx(h,Object.assign({hideOnMobile:p},{children:(()=>{switch(a){case"inline":return i.jsx(C,Object.assign({surface:t},l));case"full":return i.jsx(V,Object.assign({surface:t,size:"2XLarge"},l));default:return i.jsx(L,Object.assign({surface:t,size:"2XLarge"},l))}})()}))]}),l&&p&&i.jsx(_,{children:c?i.jsx(V,Object.assign({surface:t,size:"XLarge"},l)):i.jsx(L,Object.assign({surface:t,size:"XLarge"},l))}),p&&i.jsx(I,{viewport:r,surface:t,actions:d})]})}));exports.default=N;
